import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './_styles_/ClientApplications.css';
import { clientApplicationsType } from '../../types';
import ResetFieldButton from '../buttons/ResetFieldButton';
import ClientApplicationCreate from './ClientApplicationCreate';
import ClientApplicationsTable from './ClientApplicationsTable';

ClientApplications.propTypes = {
    clientApplications: clientApplicationsType.isRequired,
    onClientApplicationCreate: PropTypes.func.isRequired,
    onClientApplicationDelete: PropTypes.func.isRequired,
    onClientApplicationValidated: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    isChanged: PropTypes.bool.isRequired,
    backendChanged: PropTypes.bool.isRequired,
    doReset: PropTypes.bool.isRequired,
};

function ClientApplications(props) {
    const {
        clientApplications,
        onClientApplicationCreate,
        onClientApplicationDelete,
        onClientApplicationValidated,
        onReset,
        isChanged,
        backendChanged,
        doReset,
    } = props;
    const { t } = useTranslation();
    return (
        <div className={`settings-detail-tab--client-applications field${isChanged ? ' modified' : ''}`}>
            <div className="client-applications-field">
                <span className="field--key">{t('settings.client-applications.table.title')}</span>
                <ClientApplicationCreate
                    clientApplications={clientApplications}
                    onClientApplicationCreate={onClientApplicationCreate}
                />
                <ClientApplicationsTable
                    clientApplications={clientApplications}
                    onClientApplicationDelete={onClientApplicationDelete}
                    onClientApplicationValidated={onClientApplicationValidated}
                    backendChanged={backendChanged}
                    doReset={doReset}
                />
            </div>
            {isChanged && onReset && <ResetFieldButton onReset={onReset} />}
        </div>
    );
}

export default ClientApplications;
